module.exports = new __parcel__URL__("no-restriction-pencil.ef5ca06a.svg").toString();